import { BaseService } from './base.service'

export class LookupService extends BaseService {
  constructor() {
    super('Lookups')
  }
}

export const lookupSvc = new LookupService()